/*Api_V3.27*/
var ServerErrorHandler = (function (win, $) {
    var serverErrorHandler = function (redirectPages) {
        this.redirectPages = redirectPages;
        this.handlerMethod = $.proxy(this.handlerMethod, this);
        this.errorPopupMethod = function() {};
    }

    serverErrorHandler.prototype = {
        RedirectionOptionsEnum: {
            ErrorPage: 1,
            ShopPage: 2, // currently not in use
            PopupMessage: 3,
            Ignore: 4,
            Ignore_5xx: 5
        },
        errorEmitter: $({}),
        handlerMethod: function (e, options) {
            if (!options) return;

            switch(options.serverErrorHandleOption){
                case this.RedirectionOptionsEnum.ErrorPage:
                    // 1 - redirect to error page
                    this.errorEmitter.trigger('abortAll');
                    window.location.assign(this.redirectPages.error);
                    break;
                // currently no redirections to shop page defined
                case this.RedirectionOptionsEnum.ShopPage:
                    // 2 - redirect to shop page
                    this.errorEmitter.trigger('abortAll');
                    window.location.assign(this.redirectPages.shop);
                    break;
                case this.RedirectionOptionsEnum.PopupMessage:
                    // 3 - show error message in popup
                    this.errorEmitter.trigger('abortAll');
                    this.errorPopupMethod();
                    //e.preventDefault();
                    break;
                case this.RedirectionOptionsEnum.Ignore:
                    // 4 - ignore
                	break;
                case this.RedirectionOptionsEnum.Ignore_5xx:
	                options.deferred.resolve({});
	                break;
                default:
                    // 3 - show error message in popup
                    this.errorEmitter.trigger('abortAll');
                    this.errorPopupMethod();
                    //e.preventDefault();
            }
        }
    }
    return serverErrorHandler;
})(window, jQuery);

(function (win, $, app, ServerErrHandler) {
    'use strict';

    var serverErrHandler = new ServerErrHandler({ error: 'error.aspx', shop: 'default.aspx' });
    var RedirectionOptionsEnum = serverErrHandler.RedirectionOptionsEnum;
    var serverErrorHandler = serverErrHandler.handlerMethod;
    var errorEmitter = serverErrHandler.errorEmitter;

    var serviceName,
	    handlersName;

    /**
	* Helper function for creating similar wrapper methods
	*
	* @param {String} name
	* @param {Array=} argNames
	* @param {Object=} options
	* @return {Function} url Url of the server method
	*/

    var _getPostcode = function () {
        //if (window.localStorage) {
        //    var postcode = localStorage.getItem('userPostCode');
        //    return postcode && postcode.replace(/"/g, '');
        //}
        return null;
    };

    var createMethod = (function () {
        return function (name, argNames, optionsDefaults) {
            argNames = argNames || [];

            return function () {
                var api = this,
				    defaults = { type: api.o.defaultMethod, data: null, wait: false },
				    argLength = arguments.length,
				    argNamesLength = argNames.length,
				    lastArg = arguments[argLength - 1],
				    ajaxOptions = argLength > argNamesLength && typeof lastArg === 'object' ? lastArg : {};

                var options = $.extend(true, {}, defaults, optionsDefaults, ajaxOptions);

                if (options.type === api.o.handlersMethod) options.url = api.getHandlersUrl(name);
                if (options.type === api.o.serviceMethod) options.url = api.getServiceUrl(name);

                if (preventDoubleRequests(options)) {
                    var def = new $.Deferred();
                    def.reject();
                    return def.promise();
                }

                var result = parcePastdata(arguments, argNames);
                if (result) {
                    options = $.extend({}, options, result);

                    if (options && options.data && !options.data.postcode) {
                        options.data.postcode = _getPostcode();
                    }

                    return api.o.ajax($.extend(options, ajaxOptions)).then(function (data) {
                        if (data.UserGroup) {
                            var ug = app.cookie.getUserSettings('ug');
                            if (ug && !ug.match(new RegExp(data.UserGroup, 'i'))) {
                                options.data.w = 1;
                                return api.o.ajax(options);
                            }
                        }
                        return data;
                    });
                }
                errorEmitter.trigger('internalservererror');
                errorEmitter.trigger("abortAll");
                return new $.Deferred().promise();
            };
        };
    }).call(API);
	
    var currentRequests = {};

    function preventDoubleRequests(options) {
        /*check the method, is it already started then prevent double request*/
        return options.preventDoubleRequests && currentRequests[options.url];
    }

    function parcePastdata(args, argNames) {
        var options = {
            data: null
        }, i, settings;
        if (args[0] && typeof args[0] === 'object' && !$.isArray(args[0])) {
            options.data = {};
            for (i = 0; i < argNames.length; i++) {
                if (typeof args[0][argNames[i]] === 'undefined') {
                    options.data = null;
                    break;
                }
                options.data[argNames[i]] = args[0][argNames[i]];
            }
            settings = args[1];
        }
        if (!options.data) {
            options.data = {};
            for (i = 0; i < argNames.length; i++) {
                options.data[argNames[i]] = args[i];
                if (typeof options.data[argNames[i]] === 'undefined') {
                    return null;
                }
            }
            settings = args[i];
        }
        if (settings && typeof settings === 'object' && !$.isArray(settings)) {
            options = $.extend(options, settings);
        }
        return options;
    }

    var initAjax = function (options) {
        var ajaxErrors = {
            '1': 'oneSalePerOrder',
            '2': 'saleNotActive',
            '3': 'addToBasketError',
            '4': 'loginFailed',
            '5': 'registrationFailed',
            '10': 'apiUnavailable',
            '401': 'unauthorized'
        },
		    ajaxOptions = {
		        type: 'POST',
		        dataType: 'json',
		        contentType: 'application/json',
		        abortOnRetry: true,
		        preventDoubleRequests: false,
		        hideErrors: false,
		        preventErrorTriggerOnRequest: false,
		        wait: false,
		        serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage // default redirection option
		    },
		    ajaxEvents = ['success', 'error', 'beforeSend', 'complete'],
			func = options.ajaxPrefilter,
			userGroup = options.userGroup;

        $.each(ajaxEvents, function (i, event) { ajaxOptions[event] = $.noop; });

        if (!$.isFunction(func)) {
            func = $.noop;
        }

        $.extend(ajaxOptions, { waitDialog: options.waitDialog, dialog: options.dialog });

        $.ajaxSetup(ajaxOptions);

        errorEmitter.on("internalservererror", serverErrorHandler);
        errorEmitter.on("apiUnavailable", serverErrorHandler);

        $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
            var userGroup = app.cookie.getUserSettings('ug') || '';
            if (options.url.indexOf(serviceName) >= 0 || options.url.indexOf(handlersName) >= 0) {


                if (options.abortOnRetry || options.preventDoubleRequests) {
                    /*check the method, is it already started then stop it*/
                    if (currentRequests[options.url]) {
                        currentRequests[options.url].abort();
                    }
                    currentRequests[options.url] = jqXHR;
                }

                var deferred = new $.Deferred(),
				    callbacks, original = {};

                /* we need to save original ajax callbacks for the future use */
                $.each(ajaxEvents, function (i, event) { original[event] = options[event]; });

                if (options.type === 'POST') {
                	if (win.json && win.json.encode) options.data = win.json.encode(originalOptions.data);
                    else options.data = JSON.stringify(originalOptions.data);
                }
                if (options.type === 'GET') {
                    var data = options.data ? options.data.replace(/\%5B|\%5D/gi, '').split('&') : [];
                    data.push('languageID=' + app.cookie.getUserLanguage());
                    if (app.GlobalSettings && app.GlobalSettings.Country || app.GlobalSettings.Country.ID) {
                    	data.push('countryID=' + app.GlobalSettings.Country.ID);
                    	data.push('countryID=' + app.GlobalSettings.Country.ID);
                    }
                    if (userGroup == 'Admin' || userGroup == 'Staff') data.push('k=' + (new Date()).getTime());
                    data.push('userGroup=' + userGroup);
                    options.data = data.join('&');
                }

                errorEmitter.on("abortAll", function () {
                    !options.url.match(/GetConsentData|GetDataPrivacyPolicyHtml/i) && jqXHR.abort();
                });

                callbacks = {
                    success: function (data) {
                        data = data.d || data;
                        if (data.Result) {
                            original.success.call(jqXHR, data);
                            deferred.resolve(data);
                        } else {
                            var errorType = data.ErrorType;

                            if (errorType == '10') {
                                errorEmitter.trigger(ajaxErrors[errorType]);
                                data.Result = true;
                                deferred.resolve(data);
                                return;
                            }

                            options.wait && options.waitDialog && options.waitDialog.stop();
                            currentRequests[options.url] = null;
                            original.error.call(jqXHR, data);
                            setTimeout(function() {
                                deferred.reject(data);
                            }, 0);

                            /* striping html tags from error messages */
                            var message = (data.Message || '').replace(/(<([^>]+)>)/ig, '');

                            /* message should start with capital letter */
                            message = message.charAt(0).toUpperCase() + message.slice(1);

                            /* send errorMessage events to DC */
                            window.app && app.events && app.events.sendErrorMessageEvents.sendErrorMessageEvent(5000, options.url, message, window.location.host.split('.')[0] === 'm' ? true : false);


                            /* triggering ajax error events */
                            if (errorType && !options.disableErrorEmitter) {
                                errorEmitter.trigger(ajaxErrors[errorType], [message, options.hideErrors, options.data]);
                                return;
                            }
                            /* showing error message */
                            if (!options.hideErrors) options.dialog(message);
                        }
                    },
                    error: function (xhr, type, errorType) {
                        /* handle 5xx errors */
                    	if (xhr.status >= 500 && xhr.status <= 599) {
		                    options.deferred = deferred;
                            errorEmitter.trigger(ajaxErrors[10], options);
                        } else if (!$.isFunction(originalOptions.error) || !originalOptions.error(xhr, type, errorType)) {
                            errorType = (errorType || '').toLowerCase().replace(/\s*/g, '');
                            if (!errorType) {
                                errorType = ajaxErrors[xhr.status] || '';
                            }
                            !options.preventErrorTriggerOnRequest && errorEmitter.trigger(errorType, options);
                        }

                        deferred.reject();
                    },
                    beforeSend: function () {
                        if (options.wait && options.waitDialog) {
                            if (!!options.delay) {
                                options.dialog_timeout = setTimeout(function () {
                                    options.waitDialog.start();
                                }, options.delay);
                            } else {
                                options.waitDialog.start();
                            }
                        }
                        original.beforeSend.call(jqXHR);
                    },
                    complete: function () {
                        options.dialog_timeout && clearTimeout(options.dialog_timeout);
                        options.wait && options.waitDialog && options.waitDialog.stop();
                        original.complete.call(jqXHR);
                        currentRequests[options.url] = null;
                    }
                };

                $.extend(options, callbacks);
                jqXHR.waitDialog = options.waitDialog;
                $.extend(jqXHR, deferred.promise());
            }
        });
    };

    /**
	* Javascript wrapper, that simplifies and unifies
	* process of making requests to the server-side API.
	*
	* Usage:
	* var api = new API('APIService.asmx');
	* api.getSalesBanners('de9f863c-5372-4d9b-9370-5e2d50efbade', true, 1, 320, 193, {
	*     success: someCallback
	* });
	*
	* Deferred style is also possible:
	* var api = new API('APIService.asmx');
	* var getBannersXhr = api.getSalesBanners('de9f863c-5372-4d9b-9370-5e2d50efbade', true, 1, 320, 193);
	* getBannersXhr.done(someCallback)
	*
	* @param {Object} options
	* @constructor
	*/
    function API(options) {
        this.o = $.extend({}, API.settings, options);
        serviceName = this.o.serviceName = this.o.serviceName ? [this.o.serviceName, this.o.serviceExtension].join('.') : [this.o.name, this.o.serviceExtension].join('.');
        handlersName = this.o.handlersName = this.o.handlersName ? [this.o.handlersName, this.o.handlersExtension].join('.') : [this.o.name, this.o.handlersExtension].join('.');
        
        serverErrHandler.errorPopupMethod = this.o.errorPopupMethod;
        this.errorEmitter = serverErrHandler.errorEmitter;
        initAjax(options);
    }

    /**
	* API wrapper prototype object
	*
	* @type {Object}
	*/
    API.prototype = {

        getServiceUrl: function (methodName) {
            return [this.o.serviceName, methodName].join('/');
        },

        getHandlersUrl: function (methodName) {
            return [this.o.handlersName, methodName].join('/');
        },

        when: function () {
            var xhrList = [],
			    postdata = {},
				lastArg = arguments[arguments.length - 1],
				length = arguments.length,
			    readyDfd = (function () {
			        var deferred = $.Deferred();
			        $(function () { deferred.resolve() });
			        return deferred.promise();
			    }()),
				api = this;

            if (lastArg && typeof lastArg === 'object') {
                postdata = lastArg;
                length--;
            }

            for (var i = 0; i < length; i++) {
                if (arguments[i]) {
                    var method = ($.proxy(arguments[i], api));
                    xhrList.push(method(postdata, { wait: false }));
                }
            }
            xhrList.push(readyDfd);
            return $.when.apply($, xhrList);
        },
        setOptions: function (options) {
            $.ajaxSetup($.extend({}, $.ajaxSettings, options));
        },

        RedirectionOptionsEnum: RedirectionOptionsEnum,

        /* -------------------------------------------------- API METHODS START ---------------------------------------------- */

        /* ------------------ Authorize ------------------ */

        /*todo: check how this methid works*/
        addAndApplyVoucherByKey: createMethod('AddAndApplyVoucherByKey', ['key', 'imageSize'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        addAndApplyPublicVoucherByKey: createMethod('AddAndApplyPublicVoucherByKey', ['key', 'imageSize'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        addToCart: createMethod('AddToCart', ['saleID', 'itemID', 'sizeID', 'quantity'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        addItemToCart: createMethod('AddItemToCart', ['saleID', 'itemID', 'sizeID', 'quantity', 'customizableItemDetails', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        addPublicItemToCart: createMethod('AddPublicItemToCart', ['saleID', 'itemID', 'sizeID', 'quantity', 'customizableItemDetails', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        /*todo: check how this methid works*/
        addVoucherByKey: createMethod('AddVoucherByKey', ['key'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        answerContact: createMethod('AnswerContact', ['contactNo', 'comments'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        applyVouchers: createMethod('ApplyVouchers', ['vouchers', 'imageSize'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        applyVoucher: createMethod('ApplyVoucher', ['voucherID', 'imageSize'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        clearOrder: createMethod('ClearOrder', { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        clearVouchers: createMethod('clearVouchers', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createContact: createMethod('CreateContact', ['invoiceNo', 'subj', 'msg'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createReturn: createMethod('CreateReturn', ['invoiceNo', 'reason', 'items'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        decreaseOrderItem: createMethod('DecreaseOrderItem', ['itemID', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        decreasePublicOrderItem: createMethod('DecreasePublicOrderItem', ['itemID', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        deleteOrderItem: createMethod('DeleteOrderItem', ['itemID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        deleteUserDeliveryAddress: createMethod('DeleteUserDeliveryAddress', ['addressID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        forgotPassword: createMethod('ForgotPassword', ['email'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getContact: createMethod('GetContact', ['contactNo'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getContactInvoices: createMethod('GetContactInvoices', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createPublicContact: createMethod('CreatePublicContact', ['forename', 'surname', 'email', 'subject', 'comments', 'captchaResponce'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getContacts: createMethod('GetContacts', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getContactSubjects: createMethod('GetContactSubjects', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getCurrentOrder: createMethod('GetCurrentOrder', ['imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPublicCurrentOrder: createMethod('GetPublicCurrentOrder', ['imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getItemDetails: createMethod('GetItemDetails', ['itemID', 'saleID', 'getBigImages', 'includePrices'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }), //chk
        getItemQuantity: createMethod('GetItemQuantity', ['itemID', 'saleID'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }), //chk
        getItemImages: createMethod('GetItemImages', ['itemID', 'saleID'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getOrderDetails: createMethod('GetOrderDetails', ['orderID', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getOrderPaymentDetails: createMethod('GetOrderPaymentDetails', ['paymentReferenceNo', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        enterSale: createMethod('EnterSale', ['saleID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        saleIsOpen: createMethod('SaleIsOpen', ['saleID'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore_5xx }),
        enteredSale: createMethod('EnteredSale', ['saleID', 'userID', 'pos', 'cat', 'ui', 'uiv'], { type: 'GET', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        enteredSaleItem: createMethod('EnteredSaleItem', ['saleID', 'productID', 'userID', 'ui', 'uiv'], { type: 'GET', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        checkoutViewEvent: createMethod('CheckoutViewEvent', [], { type: 'GET', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        checkoutPublicViewEvent: createMethod('CheckoutPublicViewEvent', [], { type: 'GET', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        /*todo: check how this method works*/
        getPromoBanner: createMethod('GetPromoBanner', { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getOrderList: createMethod('GetOrderList', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        GetOrdersWithTracking: createMethod('GetOrdersWithTracking', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        GetPaymentsList: createMethod('GetPaymentsList', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPaymentPlans: createMethod('GetPaymentPlans', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getScheduledPayments: createMethod('GetScheduledPayments', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPastPayments: createMethod('GetPastPayments', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        processOurpayInstallment: createMethod('ProcessOurpayInstallment', ['billingAgreemntId', 'transactionId'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getMyPaymentMethods: createMethod('GetMyPaymentMethods', [], {serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        removeUserPaymentMethod: createMethod('RemoveUserPaymentMethod', ['paymentMethodToken', 'paymentMethodType'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPublicSalesBanners: createMethod('GetPublicSalesBanners', ['saleCategoryID', 'topSalesCount', 'useOzsaleSize', 'getPromotion', 'groupNo'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.ErrorPage }), //chk
        getReturnDetails: createMethod('GetReturnDetails', ['returnID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getReturnOrderDetail: createMethod('GetReturnOrderDetail', ['invoiceNo'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getReturnOrders: createMethod('GetReturnOrders', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getReturns: createMethod('GetReturns', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getSaleCategories: createMethod('GetSaleCategories', ['saleID', 'getSizes', 'getSaleInfo'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getSaleDetails: createMethod('GetSaleDetails', ['saleID'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPublicSaleDetails: createMethod('GetPublicSaleDetails', ['saleID'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getSaleItems: createMethod('GetSaleItems', ['saleID', 'imageSize'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.ErrorPage }),
        getSoldOutItems: createMethod('GetSoldOutItems', ['saleID'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getSalesBanners: createMethod('GetSalesBanners', ['saleCategoryID', 'topSalesCount', 'getBigImages', 'getPromotion', 'getPriorityStartDate', 'useOzsaleSize', 'groupNo'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.ErrorPage }),
        getSalesBannersWithSizes: createMethod('GetSalesBannersWithSizes', ['saleCategoryID', 'topSalesCount', 'bannerWidth', 'bannerHeight', 'groupNo'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.ErrorPage }),
        getEventSalesBanners: createMethod('GetEventSalesBanners', [], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getSalesCategories: createMethod('GetSalesCategories', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getSaleStatistics: createMethod('GetSaleStatistics', ['saleID', 'categoryID', 'subCategoryID'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getSubcategoryItems: createMethod('GetSubcategoryItems', ['subCategoryID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getTemplateText: createMethod('GetTemplateText', ['templateKey'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getTemplateVariantText: createMethod('GetTemplateVariantText', ['templateKey', 'variant'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getUserAddresses: createMethod('GetUserAddresses', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getUserDetails: createMethod('GetUserDetails', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getUserVouchers: createMethod('GetUserVouchers', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getVouchers: createMethod('GetVouchers', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        increaseOrderItem: createMethod('IncreaseOrderItem', ['itemID', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        increasePublicOrderItem: createMethod('IncreasePublicOrderItem', ['itemID', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        login: createMethod('Login', ['userName', 'password'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        signin: createMethod('Signin', ['userName', 'password', 'captchaResponse'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        signinCustomet: createMethod('SigninCustomer', ['userName', 'password'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        loginTicket: createMethod('LoginTicket', ['ticket'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        loginFacebook: createMethod('LoginFacebook', ['facebookUserID', 'facebookCookieValue', 'referredBy', 'invitedBy', 'voucherID', 'password', 'accessToken'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        logout: createMethod('Logout', [], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        payment: createMethod('Payment', ['cardNumber', 'cvn', 'year', 'month', 'nameOnCard', 'paypal'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        payment3Ds: createMethod('Payment3Ds', ['cardInfo', 'auth3DSResponse'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        paymenteNets: createMethod('PaymenteNets', ['cardNumber', 'cvn', 'year', 'month', 'nameOnCard', 'isMobile'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        geteNetsPaymentResult: createMethod('GeteNetsPaymentResult', ['message'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        redirectTo3Ds: createMethod('RedirectTo3Ds', ['cardInfo', 'returnUrl'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        prePayment: createMethod('PrePayment', ['deliveryAddressID'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        payPalApplyDeliveryAddress: createMethod('PayPalApplyDeliveryAddress', ['token'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        payPalConfirmOrder: createMethod('PayPalConfirmOrder', ['token'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        payPalSetCheckout: createMethod('PayPalSetCheckout', ['returnURL'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        applyDeliveryAddress: createMethod('applyDeliveryAddress', ['deliveryAddressID', 'imageSize'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setUserLanguage: createMethod('SetUserLanguage', ['languageID'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getUserLanguages: createMethod('GetUserLanguages', { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        registration: createMethod('Registration', ['forename', 'surname', 'email', 'password', 'referredBy', 'invitedBy', 'voucherID', 'parameters'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        signup: createMethod('Signup', ['forename', 'surname', 'email', 'password', 'referredBy', 'invitedBy', 'voucherID', 'parameters', 'captchaResponse'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        signupCustomet: createMethod('SignupCustomer', ['forename', 'surname', 'email', 'password', 'referredBy', 'invitedBy', 'voucherID', 'parameters'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        removeVoucher: createMethod('RemoveVoucher', ['voucherID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        returnDelete: createMethod('ReturnDelete', ['returnID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setUserDeliveryAddress: createMethod('SetUserDeliveryAddress', ['address'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setPublicDeliveryAddress: createMethod('SetPublicDeliveryAddress', ['address', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        prePaymentNewAddress: createMethod('PrePaymentNewAddress', ['address'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        changeDeliveryAddress: createMethod('ChangeDeliveryAddress', ['orderID', 'addressID'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createRefund: createMethod('CreateRefund', ['invoiceNo', 'reason', 'items'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setOrderReceived: createMethod('SetOrderReceived', ['orderID', 'satisfaction'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setAttachment: createMethod('SetAttachment', ['type', 'id', 'items'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setContact: createMethod('SetContact', ['type', 'id', 'contactNo'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        setUserDetails: createMethod('SetUserDetails', ['firstname', 'surname', 'dateBirth', 'gender', 'username', 'email', 'newPassword', 'confirmPassword', 'password'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        saveReceiveSales: createMethod('SaveReceiveSales', ['receiveInvitations'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getItemsStatistics: createMethod('GetItemsStatistics', ['saleID', 'categoryID', 'subCategoryID'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getServerSettings: createMethod('GetServerSettings', [], { serverErrorHandleOption: RedirectionOptionsEnum.ErrorPage }),
        getGoogleAnalyticsSettings: createMethod('GetGoogleAnalyticsSettings', [], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPageTemplates: createMethod('GetPageTemplates', { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getTemplateTexts: createMethod('GetTemplateTexts', ['templateKeys'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        hasPermission: createMethod('HasPermission', ['permission'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getInviteLink: createMethod('GetInviteLink', { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setInviteLink: createMethod('SetInviteLink', ['inviteLink'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        sendInvite: createMethod('SendInvite', ['emails', 'inviteText'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setUserPassword: createMethod('SetUserPassword', ['passwordRecoveryKey', 'password'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setAuthToLeave: createMethod('SetAuthToLeave', ['deliveryAddressID', 'authToLeave', 'authComment'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setPublicAuthToLeave: createMethod('SetPublicAuthToLeave', ['deliveryAddressID', 'authToLeave', 'authComment'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        unsubscribe: createMethod('Unsubscribe', ['email'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        redirectTo3P: createMethod('RedirectTo3P', ['returnUrl', 'isMobile'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        payment3P: createMethod('Payment3P', ['postData'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        publicEnterSale: createMethod('PublicEnterSale', ['saleID', 'userID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPublicSalesCategories: createMethod('GetPublicSalesCategories', [], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPpfDetailsByHtml: createMethod('Order_GetPpfDetailsByHtml', ['orderID'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPublicSaleCategories: createMethod('GetPublicSaleCategories', ['saleID', 'getSizes', 'getSaleInfo'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPublicSaleItems: createMethod('GetPublicSaleItems', ['saleID', 'imageSize'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.ErrorPage }), //chk
        getPublicSoldOutItems: createMethod('GetPublicSoldOutItems', ['saleID'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPublicItemDetails: createMethod('GetPublicItemDetails', ['itemID', 'saleID', 'getBigImages', 'includePrices'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPublicItemQuantity: createMethod('GetPublicItemQuantity', ['itemID', 'saleID'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPublicItemImages: createMethod('GetPublicItemImages', ['itemID', 'saleID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        addAndApplyVoucherByKeyEx: createMethod('AddAndApplyVoucherByKeyEx', ['key'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        saveDeliveryAddress: createMethod('SaveDeliveryAddress', ['apiAddress'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        deleteDeliveryAddress: createMethod('DeleteDeliveryAddress', ['addressID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getUserCookies: createMethod('GetUserCookies', [], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getUserCookiesXt: createMethod('GetUserCookiesXt', ['clientTime'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        confirmTermsAndConditions: createMethod('ConfirmTermsAndConditions', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        masterPassPayment: createMethod('MasterPassPayment', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        masterPassMobilePayment: createMethod('MasterPassMobilePayment', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        masterPassPostTransaction: createMethod('MasterPassPostTransaction', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getOrderTracking: createMethod('GetOrderTracking', ['orderID'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        redirectToIPay: createMethod('RedirectToIPay', ['returnUrl'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        paymentIPay: createMethod('PaymentIPay', ['postData'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getCustomNumber: createMethod('GetCustomNumber', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setCustomNumber: createMethod('SetCustomNumber', ['value'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        checkPaymentRequired: createMethod('CheckPaymentRequired', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		// searchToken
        getSearchToken: createMethod('GetSearchToken', [], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPublicSearchToken: createMethod('GetPublicSearchToken', [], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		// searchToken v2
        getSearchTokenV2: createMethod('GetSearchTokenV2', [], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPublicSearchTokenV2: createMethod('GetPublicSearchTokenV2', [], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		// braintree
        getPaymentToken: createMethod('GetPaymentToken', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getPublicPaymentToken: createMethod('GetPublicPaymentToken', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createPaymentTransaction: createMethod('CreatePaymentTransaction', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createPublicPaymentTransaction: createMethod('CreatePublicPaymentTransaction', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		createPaymentMethod: createMethod('CreatePaymentMethod', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		getPaymentMethodNonce: createMethod('GetPaymentMethodNonce', ['paymentMethodToken'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		getBraintreeUserPaymentMethods: createMethod('GetUserPaymentMethods', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		getPickupPoints: createMethod('GetPickupPoints', ['postcode'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		getPickupPointsByPostcode: createMethod('GetPublicPickupPointsByPostcode', ['postcode'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		getPickupPointsByCoordinates: createMethod('GetPublicPickupPointsByCoordinates', ['lat', 'lng', 'radius', 'count'], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		setAddressAdditionalData: createMethod('SetAddressAdditionalData', ['deliveryAddressID', 'additionalData'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setDeliveryOption: createMethod('SetDeliveryOption', ['optionParameters', 'imageSize'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        setPublicDeliveryOption: createMethod('SetPublicDeliveryOption', ['optionParameters', 'imageSize'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        normalizePhoneAndSendCode: createMethod('NormalizePhoneAndSendCode', ['phone'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        publicNormalizePhoneAndSendCode: createMethod('PublicNormalizePhoneAndSendCode', ['phone', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		verificationCodeSend: createMethod('VerificationCodeSend', ['phone'], { serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        verificationCodeConfirm: createMethod('VerificationCodeConfirm', ['phone', 'code'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        verificationPublicCodeConfirm: createMethod('VerificationPublicCodeConfirm', ['phone', 'code', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		// DC tracking
		setMarketingData: createMethod('SetMarketingData', ['data'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		sendSearchEvent: createMethod('SendSearchEvent', ['brandsCount', 'categoriesCount', 'sizesCount', 'minPrice', 'maxPrice', 'resCount', 'term'], { type: 'POST', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		sendPPAddressSelectedEvent: createMethod('SendPickupPointAddressSelectionEvent', [], { type: 'POST', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		sendPPAddressPromoLabelClickedEvent: createMethod('SendPickupPointPromoLabelClickEvent', [], { type: 'POST', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
		loginVisa: createMethod('LoginVisa', ['data', 'referredBy', 'invitedBy', 'voucherID', 'password'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
		saveBillingAddress: createMethod('SaveBillingAddress', ['data'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getDeliveryServicePackageDetails: createMethod('GetDeliveryServicePackageDetails', { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getPublicDeliveryServicePackageDetails: createMethod('GetPublicDeliveryServicePackageDetails', { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        saveConsentData: createMethod('SaveConsentData', [], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.Ignore_5xx }),
        getConsentData: createMethod('GetConsentData', [], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.Ignore_5xx }),
        saveAgeRestrictedConsentData: createMethod('SaveAgeRestrictedConsentData', ['date'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.Ignore_5xx }),
        getPrices: createMethod('GetPrices', ['postcode', 'pickupPoint'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.Ignore_5xx }),
        getDeliveryPrice: createMethod('GetDeliveryPrice', ['postcode', 'pickupPoint'], { type: 'POST', serverErrorHandleOption: RedirectionOptionsEnum.Ignore_5xx }),
        getDeliveryServicePackageByCustomer: createMethod('GetDeliveryServicePackageByCustomer', { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        unsubscribeDeliveryServicePackage: createMethod('UnsubscribeDeliveryServicePackage', ['packageId'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getDataPrivacyPolicyHtml: createMethod('GetDataPrivacyPolicyHtml', [], { type: 'GET', serverErrorHandleOption: RedirectionOptionsEnum.Ignore_5xx }),
        sendLandingSiteEvent: createMethod('SendLandingSiteEvent', ['pageUrl'], { type: 'POST', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        getTracking: createMethod('GetTracking', ['carrier', 'tracking'], { type: 'POST', preventErrorTriggerOnRequest: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),
        registrationWithoutPassword: createMethod('RegistrationWithoutPassword', ['forename', 'surname', 'identification', 'registrationType'], { wait: true, serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        createAfterpayOrder: createMethod('CreateAfterpayOrder', ['redirectUrl'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createOpenpayOrder: createMethod('CreateOpenpayOrder', ['redirectUrl'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        createPublicAfterpayOrder: createMethod('CreatePublicAfterpayOrder', ['redirectUrl', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createPublicOpenpayOrder: createMethod('CreatePublicOpenpayOrder', ['redirectUrl', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        afterPayCreatePayment: createMethod('AfterPayCreatePayment', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        openpayCapturePayment: createMethod('OpenpayCapturePayment', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        afterPayCreatePublicPayment: createMethod('AfterPayCreatePublicPayment', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        openpayCapturePublicPayment: createMethod('OpenpayCapturePublicPayment', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),


        createHummPaymentRequest: createMethod('CreateHummPaymentRequest', ['callback'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createHummOrder: createMethod('CreateHummOrder', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        getZipCheckout: createMethod('GetZipCheckout', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),
        createZipCharge: createMethod('CreateZipCharge', ['data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        checkoutView: createMethod('CheckoutView', [], { type: 'POST', wait: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),

        switchBasketMode: createMethod('SwitchBasketMode', ['mode'], { type: 'POST', wait: true, serverErrorHandleOption: RedirectionOptionsEnum.Ignore }),

        setUserGiftAddress: createMethod('SetUserGiftAddress', ['address'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        setUserPublicGiftAddress: createMethod('SetUserPublicGiftAddress', ['address', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        getUserGiftAddresses: createMethod('GetUserGiftAddresses', [], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        setGiftParameters: createMethod('SetGiftParameters', ['giftMessage', 'giftOccasion', 'giftStyle', 'giftDate'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        setUserBillingAddress: createMethod('SetUserBillingAddress', ['address'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        setPublicBillingAddress: createMethod('SetPublicBillingAddress', ['address', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        setUserGiftAndBillingAddress: createMethod('SetUserGiftAndBillingAddress', ['address', 'billingAddress'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        setPublicGiftAndBillingAddress: createMethod('SetPublicGiftAndBillingAddress', ['address', 'billingAddress', 'data'], { serverErrorHandleOption: RedirectionOptionsEnum.PopupMessage }),

        version: '3.27'
	};

	/**
	* Global Api wrapper settings.
	*
	* @type {Object}
	*/
	API.settings = {

		ajax: $.ajax,

		name: 'APIService',

		serviceName: false,

		handlersName: false,

		serviceExtension: 'asmx',

		handlersExtension: 'ashx',

		serviceMethod: 'POST',

		handlersMethod: 'GET',

		defaultMethod: 'POST'

	};

	window.API = API;

})(window, jQuery, app, ServerErrorHandler);
